import React from 'react';
import { 
  FirstImg,
  SecondImg,
  ThirdImg,
  FourthImg,
  FiveImg,
  SixImg,
  SevenImg,
  EightImg
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { IncorrectImg, P } from '@helpers';


export const IncorrectLogo = ({t}) => {
    return (
      <PageWrapper>
        <Container paddingTop='78px' marginLeft='101px' paddingBottom='90px'>
          <P weight='400' size='25px' height='20px'>{t("Incorrect logo reproduction")}</P>
          <FlexDiv>
            <Text width='317px' paddingAffterText="27px" paddingBefforeText="45px">
            <p>
              {t("The incorrect reproduction of the logo and its elements is described and illustrated below.")} 
            </p>
            <ul>
              <li>
                {t("- Changing the layout of the logo components")}
              </li>
              <li>
                {t("- Changing the proportions of the logo and its components")} 
              </li>
              <li>
                {t("- Changing the fonts of the logo")} 
              </li>
              <li>
                {t("- Changing primary and additional colors")}
              </li>
            </ul>
            <ul>
              <li>
                {t("- Adding outlines to the logo")}
              </li>
              <li>
                {t("- Adding shadows and effects to the logo")}
              </li>
              <li>
                {t("- Removal of any logo components")}
              </li>
              <li>
                {t("- Adding new components to the logo")}
              </li>
            </ul>
            </Text>
            <FlexDiv marginLeft="50px">
              <FlexDiv direction='column'>
                <IncorrectImg marginTop='42px'>
                  <FirstImg/>
                </IncorrectImg>
                <IncorrectImg marginTop='35px'>
                  <ThirdImg/>
                </IncorrectImg>
                <IncorrectImg marginTop='35px'>
                  <FiveImg/>
                </IncorrectImg>
                <IncorrectImg marginTop='35px'>
                  <SevenImg/>
                </IncorrectImg>
              </FlexDiv>
              <FlexDiv direction='column' marginRight="28px">
                <IncorrectImg marginTop='42px'>
                  <SecondImg/>
                </IncorrectImg>
                <IncorrectImg marginTop='35px'>
                  <FourthImg/>
                </IncorrectImg>
                <IncorrectImg marginTop='35px'>
                  <SixImg/>
                </IncorrectImg>
                <IncorrectImg marginTop='35px'>
                  <EightImg/>
                </IncorrectImg>
              </FlexDiv>
            </FlexDiv>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
